import React from "react";
import PropTypes from "prop-types";

import MDBox from "shared/components/MDBox";
import TableFacturasContent from "./TableFacturasContent";

function TableFacturas({ refreshFlag, onError }) {
  return (
    <MDBox>
      <TableFacturasContent refreshFlag={refreshFlag} onError={onError} />
    </MDBox>
  );
}

TableFacturas.propTypes = {
  refreshFlag: PropTypes.bool,
  onError: PropTypes.func,
};

TableFacturas.defaultProps = {
  refreshFlag: false,
  onError: null,
};

export default TableFacturas;
